import React, { useState } from 'react';
import { SECONDARY_NUMBER, PRIMARY_NUMBER, EMAIL } from '../lib/constants';
import { X, Instagram, Facebook, Phone, Mail } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear() || 2026;
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  return <>
      <footer id="footer" className="bg-[#020202] pt-16 pb-8 border-t border-gray-900" data-id="element-145">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
          {/* Main Footer Content */}
          <div className="flex flex-col items-center gap-10 mb-12" data-id="element-147">
            {/* Logo — same as header */}
            <a href="#inicio" className="inline-block" data-id="element-148">
              <img src="https://cdn.magicpatterns.com/uploads/sTBYKR7U6bMKUaUtjJjf8a/WhatsApp_Image_2026-04-23_at_00.43.05.jpg" alt="MOBAL FUMIGACIONES" className="h-20 sm:h-24 w-auto object-contain rounded-full mix-blend-screen" data-id="element-149" />
            </a>

            <p className="text-gray-400 font-body text-center text-sm" data-id="element-150">
              MOBAL FUMIGACIONES — Rosario, Santa Fe
            </p>

            {/* Contact Info */}
            <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-10" data-id="element-151">
              <div className="flex items-center gap-3" data-id="element-152">
                <Phone className="w-5 h-5 text-mobal-green flex-shrink-0" data-id="element-153" />
                <div className="text-center sm:text-left" data-id="element-154">
                  <p className="text-mobal-white font-bold font-body" data-id="element-155">
                    {SECONDARY_NUMBER}
                  </p>
                  <p className="text-mobal-white font-bold font-body" data-id="element-156">
                    {PRIMARY_NUMBER}
                  </p>
                </div>
              </div>

              <a href={`mailto:${EMAIL}`} className="flex items-center gap-3 text-gray-400 hover:text-mobal-green transition-colors font-body" data-id="element-157">
                <Mail className="w-5 h-5 text-mobal-green flex-shrink-0" data-id="element-158" />
                {EMAIL}
              </a>
            </div>

            {/* Social Media Icons */}
            <div className="flex items-center gap-5" data-id="element-159">
              <a href="https://instagram.com/mobalfumigaciones" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-11 h-11 rounded-full border border-gray-700 text-gray-400 hover:border-mobal-green hover:text-mobal-green transition-all" aria-label="Instagram de MOBAL FUMIGACIONES" data-id="element-160">
                <Instagram className="w-5 h-5" data-id="element-161" />
              </a>
              <a href="https://www.facebook.com/share/1AkZzwzFeJ/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-11 h-11 rounded-full border border-gray-700 text-gray-400 hover:border-mobal-green hover:text-mobal-green transition-all" aria-label="Facebook de MOBAL FUMIGACIONES" data-id="element-162">
                <Facebook className="w-5 h-5" data-id="element-163" />
              </a>
            </div>
          </div>

          {/* Legal Bar — unchanged */}
          <div className="border-t border-gray-800 pt-8 text-center flex flex-col items-center gap-4" data-id="element-164">
            <p className="text-gray-500 text-sm font-body" data-id="element-165">
              © {currentYear} MOBAL FUMIGACIONES – Todos los derechos
              reservados
            </p>
            <div className="flex items-center gap-4 text-sm text-gray-500 font-body" data-id="element-166">
              <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-mobal-green transition-colors underline underline-offset-2" data-id="element-167">
                Política de Privacidad
              </button>
              <span data-id="element-168">|</span>
              <button onClick={() => setIsTermsOpen(true)} className="hover:text-mobal-green transition-colors underline underline-offset-2" data-id="element-169">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      {isPrivacyOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-id="element-170">
          <div className="bg-white rounded-xl max-w-2xl w-full max-h-[80vh] flex flex-col overflow-hidden" data-id="element-171">
            <div className="flex justify-between items-center p-6 border-b border-gray-200" data-id="element-172">
              <h3 className="text-2xl font-heading font-bold text-mobal-black" data-id="element-173">
                Política de Privacidad
              </h3>
              <button onClick={() => setIsPrivacyOpen(false)} className="text-gray-500 hover:text-mobal-black" data-id="element-174">
                <X className="w-6 h-6" data-id="element-175" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto text-gray-700 font-body space-y-4" data-id="element-176">
              <p data-id="element-177">
                En MOBAL FUMIGACIONES, respetamos su privacidad y nos
                comprometemos a proteger sus datos personales. Esta política
                explica cómo recopilamos, usamos y protegemos la información que
                usted nos proporciona al utilizar nuestros servicios de control
                de plagas.
              </p>
              <h4 className="font-bold text-mobal-black mt-4" data-id="element-178">
                1. Información que recopilamos
              </h4>
              <p data-id="element-179">
                Recopilamos información personal que usted nos proporciona
                voluntariamente, como su nombre, dirección, número de teléfono,
                dirección de correo electrónico y detalles sobre su propiedad
                necesarios para brindar nuestros servicios de fumigación.
              </p>
              <h4 className="font-bold text-mobal-black mt-4" data-id="element-180">
                2. Uso de la información
              </h4>
              <p data-id="element-181">
                Utilizamos su información para: programar y realizar servicios
                de control de plagas, enviarle presupuestos, procesar pagos,
                comunicarnos sobre su servicio y cumplir con las normativas
                sanitarias vigentes en Rosario y alrededores.
              </p>
              <h4 className="font-bold text-mobal-black mt-4" data-id="element-182">
                3. Protección de datos
              </h4>
              <p data-id="element-183">
                Implementamos medidas de seguridad para proteger su información
                personal contra acceso no autorizado, alteración o divulgación.
                No vendemos ni compartimos su información con terceros con fines
                de marketing.
              </p>
            </div>
            <div className="p-6 border-t border-gray-200 bg-gray-50 flex justify-end" data-id="element-184">
              <button onClick={() => setIsPrivacyOpen(false)} className="bg-mobal-black text-white px-6 py-2 rounded-md font-bold hover:bg-gray-800 transition-colors" data-id="element-185">
                Cerrar
              </button>
            </div>
          </div>
        </div>}

      {/* Terms & Conditions Modal */}
      {isTermsOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-id="element-186">
          <div className="bg-white rounded-xl max-w-2xl w-full max-h-[80vh] flex flex-col overflow-hidden" data-id="element-187">
            <div className="flex justify-between items-center p-6 border-b border-gray-200" data-id="element-188">
              <h3 className="text-2xl font-heading font-bold text-mobal-black" data-id="element-189">
                Términos y Condiciones
              </h3>
              <button onClick={() => setIsTermsOpen(false)} className="text-gray-500 hover:text-mobal-black" data-id="element-190">
                <X className="w-6 h-6" data-id="element-191" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto text-gray-700 font-body space-y-4" data-id="element-192">
              <p data-id="element-193">
                Al contratar los servicios de MOBAL FUMIGACIONES, usted acepta
                los siguientes términos y condiciones:
              </p>
              <h4 className="font-bold text-mobal-black mt-4" data-id="element-194">1. Servicios</h4>
              <p data-id="element-195">
                MOBAL FUMIGACIONES se compromete a realizar servicios
                profesionales de control de plagas utilizando productos
                autorizados por ANMAT. Los resultados pueden variar según el
                tipo de plaga, nivel de infestación y condiciones estructurales.
              </p>
              <h4 className="font-bold text-mobal-black mt-4" data-id="element-196">
                2. Preparación y Precauciones
              </h4>
              <p data-id="element-197">
                El cliente es responsable de seguir las instrucciones de
                preparación previas al servicio y las precauciones posteriores
                indicadas por nuestros técnicos para garantizar la seguridad de
                personas y mascotas, así como la efectividad del tratamiento.
              </p>
              <h4 className="font-bold text-mobal-black mt-4" data-id="element-198">3. Garantía</h4>
              <p data-id="element-199">
                Ofrecemos garantía sobre nuestros servicios sujeta a las
                condiciones específicas detalladas en el presupuesto o informe
                técnico entregado. La garantía puede anularse si no se siguen
                las recomendaciones estructurales o de higiene indicadas.
              </p>
              <h4 className="font-bold text-mobal-black mt-4" data-id="element-200">
                4. Pagos y Facturación
              </h4>
              <p data-id="element-201">
                Los pagos deben realizarse según lo acordado al momento de la
                contratación. Emitimos factura C por nuestros servicios.
              </p>
            </div>
            <div className="p-6 border-t border-gray-200 bg-gray-50 flex justify-end" data-id="element-202">
              <button onClick={() => setIsTermsOpen(false)} className="bg-mobal-black text-white px-6 py-2 rounded-md font-bold hover:bg-gray-800 transition-colors" data-id="element-203">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}